import { Inject } from '@odinjs/odin';

import { AutocompleteAPI, DeckAPI, PanelAPI } from '@philips-emr/tws-components';
import Controller, { OnAfterFetch, OnChange, OnSelectItem } from '@philips-emr/tws-core/lib/client';
import { ChangeEvent, FetchEvent, SelectItemEvent } from '@philips-emr/tws-core/lib/component/types';
import { isEmptyArrayOrObject } from '@philips-emr/tws-utils';

import { NegotiationValueSidebarMenuAliases as Aliases, FragmentNames } from '../../codegen';

enum NegotiationMenu {
  PROPOSAL = '1',
  PROCEDURES = '2',
  SERVICES = '3',
  MATERIALS = '4',
  PACKAGES = '5',
}

@Controller({ fragment: FragmentNames.NEGOTIATION_VALUE_SIDEBAR_MENU })
class NegotiationValueSidebarMenuController {
  @Inject(Aliases.PANEL_PROPOSAL)
  private panelProposal: PanelAPI;
  @Inject(Aliases.PANEL_PROCEDURES)
  private panelProcedures: PanelAPI;
  @Inject(Aliases.PANEL_MATERIALS)
  private panelMaterials: PanelAPI;
  @Inject(Aliases.PANEL_PACKAGES)
  private panelPackages: PanelAPI;
  @Inject(Aliases.PANEL_SERVICES)
  private panelServices: PanelAPI;
  @Inject(Aliases.DECK_MENU)
  private deckMenu: DeckAPI;
  @Inject(Aliases.AUTOCOMPLETE_MENU_MOBILE)
  private autocompleteMenuMobile: AutocompleteAPI;

  @OnAfterFetch(Aliases.FETCH_MENU)
  onAfterFetch(): void {
    this.deckMenu.selectCard(NegotiationMenu.PROPOSAL);
  }

  @OnSelectItem(Aliases.DECK_MENU)
  onselect(event: SelectItemEvent<{ id: NegotiationMenu }>): void {
    const { id } = event.item;
    this.visibilityControl(id);
  }

  private visibilityControl(menu: string): void {
    this.panelProposal.setVisible(menu == NegotiationMenu.PROPOSAL);
    this.panelProcedures.setVisible(menu == NegotiationMenu.PROCEDURES);
    this.panelMaterials.setVisible(menu == NegotiationMenu.MATERIALS);
    this.panelPackages.setVisible(menu == NegotiationMenu.PACKAGES);
    this.panelServices.setVisible(menu == NegotiationMenu.SERVICES);
  }

  @OnChange(Aliases.AUTOCOMPLETE_MENU_MOBILE)
  onchangeAutoComplete(event: ChangeEvent<{ id: NegotiationMenu }>): void {
    this.visibilityControl(event.value.id);
  }

  @OnAfterFetch(Aliases.FETCH_MENU_MOBILE)
  onAfterFetchMobile(event: FetchEvent): void {
    if (event.data && !isEmptyArrayOrObject(event.data)) {
      const data = event.data as [{}];
      this.autocompleteMenuMobile.setValue(data[0]);
    }
  }

}

export {
  NegotiationValueSidebarMenuController,
};
